import React, { useState } from "react";
import { PrgressBar, Button, Container } from "react-bootstrap";
import "./Banner.css"; // Ensure you have this file for styling

const Banner = () => {
  const [raisedAmount] = useState(14);
  const goal = 20;
  const progress = (raisedAmount / goal) * 100;

  return (
    <Container className="work-banner-container">
      <div className="work-banner-box">
        <h3 style={{ fontSize: 40 }} className="mb-4">
          When the impact matters, investing in telling the story is important!
        </h3>
        <h4 className="mb-4">
          The Impact Stories Fund is a project founded and funded by SPARK Publicity. 
          Our mission is to amplifying transformative narratives that showcase the real-world impact of social initiatives, inspiring action and fostering meaningful change.
        </h4>
        {/* <h4>For each new group, ${goal.toLocaleString()} is needed.</h4>
        <h5 className="mb-5">
          The money bar for the next group is now at{" "}
          <strong>${raisedAmount.toLocaleString()}</strong>.
        </h5> */}
        {/* <a href="/donate">
          <Button
            variant="warning"
            size="lg"
            style={{ backgroundColor: "#ffc107", fontWeight: "bold" }}
          >
            Donate!!
          </Button>
        </a> */}
      </div>
    </Container>
  );
};

export default Banner;
